import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMaterialUIController, setOpenConfigurator, setOpenAccountMenu } from "context";
import { Paper, IconButton, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"; // Icon for Planejamento
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import AssessmentIcon from "@mui/icons-material/Assessment";

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(() => {
    if (location.pathname.startsWith("/dashboard")) return 0;
    if (location.pathname.startsWith("/Plajejamento")) return 1; // Match the route
    if (location.pathname.startsWith("/lancamentos")) return 2;
    if (location.pathname.startsWith("/configuracoes")) return 3;
    if (location.pathname.startsWith("/relatorios")) return 4;
    return -1;
  });

  const [controller, dispatch] = useMaterialUIController();

  const selectedColor = "#01e6f3"; // Blue when selected
  const unselectedColor = "#90caf9";

  const handleNav = (action, index) => {
    console.log("Navigating to index:", index); // Debug log
    setValue(index);
    if (action === "account") return setOpenAccountMenu(dispatch, true);
    if (action === "configuracoes") return setOpenConfigurator(dispatch, true);
    if (action === "home") return navigate("/dashboard");
    if (action === "Planejamento") return navigate("/Plajejamento"); // Redirect to the specified route
    if (action === "lancamentos") return navigate("/lancamentos");
    if (action === "relatorios") return navigate("/relatorios");
  };

  return (
    <Paper
      elevation={10}
      sx={{
        position: "fixed",
        bottom: 10, // Aumentado para dar mais espaço da borda inferior
        left: 0,
        right: 0,
        zIndex: 1100,
        bgcolor: "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(10px)",
        px: 2,
        py: 1, // Aumentado para mais espaço interno
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
        mt: 6, // Adicionado margem superior para elevar ainda mais no mobile
      }}
    >
      <Box display="flex" justifyContent="space-around" alignItems="center">
        <IconButton
          onClick={() => handleNav("home", 0)}
          sx={{
            "& svg": {
              fontSize: value === 0 ? "41.4px" : "36px",
              color: value === 0 ? selectedColor : unselectedColor,
              transition: "transform 0.2s ease, color 0.2s ease",
              transform: value === 0 ? "scale(1.15)" : "scale(1)",
            },
          }}
        >
          <HomeIcon />
        </IconButton>
        <IconButton
          onClick={() => handleNav("Planejamento", 1)} // Action name changed to "Planejamento"
          sx={{
            "& svg": {
              fontSize: value === 1 ? "41.4px" : "36px",
              color: value === 1 ? selectedColor : unselectedColor,
              transition: "transform 0.2s ease, color 0.2s ease",
              transform: value === 1 ? "scale(1.15)" : "scale(1)",
            },
          }}
        >
          <AccountBalanceWalletIcon />
        </IconButton>
        <IconButton
          onClick={() => handleNav("lancamentos", 2)}
          sx={{
            "& svg": {
              fontSize: value === 2 ? "41.4px" : "36px",
              color: value === 2 ? selectedColor : unselectedColor,
              transition: "transform 0.2s ease, color 0.2s ease",
              transform: value === 2 ? "scale(1.15)" : "scale(1)",
            },
          }}
        >
          <AddCircleIcon />
        </IconButton>
        <IconButton
          onClick={() => handleNav("relatorios", 4)}
          sx={{
            "& svg": {
              fontSize: value === 4 ? "41.4px" : "36px",
              color: value === 4 ? selectedColor : unselectedColor,
              transition: "transform 0.2s ease, color 0.2s ease",
              transform: value === 4 ? "scale(1.15)" : "scale(1)",
            },
          }}
        >
          <AssessmentIcon />
        </IconButton>
        <IconButton
          onClick={() => handleNav("configuracoes", 3)}
          sx={{
            "& svg": {
              fontSize: value === 3 ? "41.4px" : "36px",
              color: value === 3 ? selectedColor : unselectedColor,
              transition: "transform 0.2s ease, color 0.2s ease",
              transform: value === 3 ? "scale(1.15)" : "scale(1)",
            },
          }}
        >
          <SettingsIcon />
        </IconButton>
      </Box>
    </Paper>
  );
}
